import { atom } from "recoil";

export type TTranslations = Record<string, string>;

export const translationAtom = atom<TTranslations>({
  key: "translations",
  default: { LocalesNotFetchedYet: "LocalesNotFetchedYet" },
});